import React from "react";

const CropChemRoot = () => {
  return (
			<div></div>
	)
}

export default CropChemRoot;